import { Model } from "survey-core";
import "survey-core/i18n/french";
import { renderSurvey } from "survey-js-ui";
import "survey-core/survey-core.min.css";

const style = document.createElement("style");
style.textContent = `
  :root {
    --primary-color: #f2513c;
    --secondary-color: #a0d348;
    --accent-color: #2098ae;
    --neutral-color: #ffffff;
    --font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  }
  #landingPage, #completionPage {
    max-width: 800px;
    margin: 2rem auto;
    padding: 2rem;
    font-family: var(--font-family);
    line-height: 1.6;
    color: #333;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  }
  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 2rem;
    margin-bottom: 1.5rem;
  }
  .page-header h1 {
    font-size: 2.2rem;
    margin: 0;
    color: #1a1a1a;
    flex: 1;
  }
  .page-header h1.long-title {
    font-size: 1.5rem;
    line-height: 1.3;
  }
  @media (max-width: 600px) {
    .page-header h1.long-title {
      font-size: 1.2rem;
    }
  }
  .page-header img {
    max-width: 250px;
    max-height: 100px;
    display: block;
    object-fit: contain;
  }
  #surveyHeader {
    display: none;
  }
  #landingPage .welcome-text, #completionPage .completion-text {
    font-size: 1.2rem;
    margin-bottom: 2rem;
    text-align: center;
  }
  #landingPage .welcome-text {
    text-align: left;
    white-space: pre-wrap;
  }
  #landingPage .expand-section {
    border-top: 1px solid #eee;
    padding-top: 1.5rem;
    margin-bottom: 2rem;
  }
  #landingPage .expand-trigger {
    cursor: pointer;
    font-weight: 600;
    color: var(--primary-color);
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 1.1rem;
    user-select: none;
  }
  #landingPage .expand-trigger::after {
    content: "▼";
    font-size: 0.8rem;
    transition: transform 0.2s;
  }
  #landingPage .expand-trigger.open::after {
    transform: rotate(180deg);
  }
  #landingPage .expand-content {
    display: none;
    margin-top: 1rem;
    color: #555;
    white-space: pre-wrap;
  }
  #landingPage .expand-content.open {
    display: block;
  }
  #landingPage .actions {
    display: flex;
    gap: 1rem;
    align-items: center;
    margin-top: 2rem;
  }
  #landingPage button {
    background: var(--primary-color);
    color: white;
    border: none;
    padding: 0.8rem 1.8rem;
    font-size: 1.1rem;
    font-weight: 600;
    border-radius: 6px;
    cursor: pointer;
    transition: opacity 0.2s;
  }
  #landingPage button:hover {
    opacity: 0.9;
  }
  #landingPage .more-info {
    color: #666;
    text-decoration: underline;
    font-size: 0.95rem;
  }
  
  .completion-footer {
    margin-top: 3rem;
    padding-top: 2rem;
    border-top: 1px solid #eee;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
    text-align: center;
  }
  .credit-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
  }
  .credit-item span {
    font-size: 0.9rem;
    color: #666;
  }
  .credit-item a img {
    height: 50px;
    width: auto;
    max-width: 200px;
    object-fit: contain;
    transition: transform 0.2s;
    display: block;
  }
  .credit-item a:hover img {
    transform: scale(1.05);
  }
  
  /* SurveyJS Overrides */
  .sd-root-modern, .sd-container-modern, .sv-root-modern, .sv-container-modern {
    background-color: #ffffff !important;
    margin-top: 0;
  }

  /* Progress Bar -> ACCENT */
  .sd-progress__bar, .sv-progress__bar, .sd-progress__bar-value, .sv-progress__bar-value {
    background-color: var(--accent-color) !important;
  }

  /* Checkboxes & Radios -> PRIMARY */
  .sd-checkbox--checked .sd-checkbox__svg, .sv-checkbox--checked .sv-checkbox__svg,
  .sd-radio--checked .sd-radio__svg, .sv-radio--checked .sv-radio__svg,
  .sd-item--selected .sd-item__control-label, .sv-item--selected .sv-item__control-label {
    fill: var(--primary-color) !important;
    stroke: var(--primary-color) !important;
  }
  
  .sd-checkbox, .sd-radio, .sv-checkbox, .sv-radio, .sd-item, .sv-item {
    --sjs-primary-color: var(--primary-color) !important;
    --sjs-primary-backcolor: var(--primary-color) !important;
  }

  /* Previous Button -> SECONDARY */
  button[class*="navigation__button--prev"] {
    background-color: transparent !important;
    color: var(--secondary-color) !important;
    border: 1px solid var(--secondary-color) !important;
  }
  button[class*="navigation__button--prev"]:hover {
    background-color: var(--secondary-color) !important;
    color: #ffffff !important;
  }

  /* Logo in Survey */
  .sd-logo, .sv-logo, img[class*="logo"] {
    max-width: 400px !important;
    max-height: 150px !important;
    height: auto !important;
    object-fit: contain !important;
    display: block !important;
  }
  .sd-header, .sv-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    padding: 1.5rem !important;
  }
  .sd-header__title, .sv-header__title {
    flex: 1 !important;
  }

  /* Réduction du titre interne au sondage quand il est long */
  #surveyContainer.long-title-survey .sd-container-modern__title .sd-title,
  #surveyContainer.long-title-survey .sd-title {
    font-size: 1.8rem !important;
    line-height: 1.3 !important;
  }

  @media (max-width: 600px) {
    #surveyContainer.long-title-survey .sd-container-modern__title .sd-title,
    #surveyContainer.long-title-survey .sd-title {
      font-size: 1.4rem !important;
    }
  }

  /* Next/Complete Buttons -> PRIMARY */
  button[class*="navigation__button--next"],
  button[class*="navigation__button--complete"],
  button[class*="btn--action"],
  .sd-btn--action, .sv-btn--action {
    background-color: var(--primary-color) !important;
    color: #ffffff !important;
    border: none !important;
  }
  
  button[class*="navigation__button--next"]:hover,
  button[class*="navigation__button--complete"]:hover,
  button[class*="btn--action"]:hover,
  .sd-btn--action:hover, .sv-btn--action:hover {
    background-color: var(--primary-color) !important;
    color: #ffffff !important;
    filter: brightness(0.9) !important;
  }
`;

function applyBranding(branding: any) {
  const root = document.documentElement;
  const b = {
    primaryColor: "#f2513c",
    secondaryColor: "#a0d348",
    accentColor: "#2098ae",
    neutralColor: "#ffffff",
    fontFamily: "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
    ...branding,
  };

  root.style.setProperty("--primary-color", b.primaryColor);
  root.style.setProperty("--secondary-color", b.secondaryColor);
  root.style.setProperty("--accent-color", b.accentColor);
  root.style.setProperty("--neutral-color", b.neutralColor);
  root.style.setProperty("--font-family", b.fontFamily);

  root.style.setProperty("--sjs-primary-color", b.primaryColor);
  root.style.setProperty("--sjs-primary-backcolor", b.primaryColor);
  root.style.setProperty("--sjs-font-family", b.fontFamily);
}

const apiUrl = import.meta.env.VITE_API_URL as string;

const path = window.location.pathname.replace(/^\//, "").replace(/\/$/, "");
const parts = path.split("/");

const container = document.getElementById("surveyContainer")!;

async function init() {
  let projectId: string;
  let surveyId: string;
  let token: string | undefined;
  let prefillData: Record<string, any> = {};

  const tokenIdx = parts.indexOf("t");
  if (tokenIdx !== -1 && parts[tokenIdx + 1]) {
    token = parts[tokenIdx + 1];
    const res = await fetch(`${apiUrl}/token-check/${token}`);
    if (!res.ok) {
      if (res.status === 403) {
        container.textContent = "Ce lien a déjà été utilisé pour soumettre une réponse.";
      } else if (res.status === 404) {
        container.textContent = "Lien invalide ou expiré.";
      } else {
        container.textContent = "Erreur lors de la vérification du lien.";
      }
      return;
    }
    const tokenData = await res.json();
    projectId = tokenData.projectId;
    surveyId = tokenData.surveyId;
    prefillData = {
      name: tokenData.name,
      email: tokenData.email,
      ...(tokenData.metadata || {}),
    };
  } else if (parts.length === 1 && parts[0]) {
    const slug = parts[0];
    const res = await fetch(`${apiUrl}/resolve-slug/${slug}`);
    if (!res.ok) {
      container.textContent =
        res.status === 404 ? "Sondage introuvable (slug inconnu)." : "Erreur de résolution.";
      return;
    }
    const data = await res.json();
    projectId = data.projectId;
    surveyId = data.surveyId;
  } else if (parts.length >= 2) {
    [projectId, surveyId] = parts;
  } else {
    container.textContent = "URL invalide. Format attendu: /nom-du-sondage ou /{projectId}/{surveyId}";
    return;
  }

  const res = await fetch(`${apiUrl}/projects/${projectId}/surveys/${surveyId}`);
  if (!res.ok) {
    container.textContent = res.status === 404 ? "Sondage introuvable." : "Erreur de chargement.";
    return;
  }

  const data = await res.json();
  applyBranding(data.branding);

  if (data.status !== "active") {
    container.textContent = "Ce sondage n'est plus disponible.";
    return;
  }

  function showGenericCompletionPage() {
    const branding = data.branding || {};
    container.innerHTML = `
      <div id="completionPage">
        <div class="page-header" style="justify-content: center; margin-bottom: 3rem;">
          ${branding.logoUrl ? `<img src="${branding.logoUrl}" alt="Logo Projet" />` : ""}
        </div>
        <div class="completion-text">
          <h2 style="color: var(--primary-color); font-size: 1.8rem; margin-bottom: 1rem;">Merci !</h2>
          <p>Merci d'avoir répondu à ce sondage !</p>
        </div>
        
        <div class="completion-footer">
          <div class="credit-item">
            <span>Sondage administré par</span>
            <a href="https://www.medaillonconseils.com/" target="_blank">
              <img src="/logo-medaillon.png" alt="Médaillon Groupe Conseils" />
            </a>
          </div>
          <div class="credit-item">
            <span>propulsé par</span>
            <a href="https://opubliq.com/" target="_blank">
              <img src="/logo-opubliq.svg" alt="Opubliq" />
            </a>
          </div>
        </div>
      </div>
    `;
  }

  function startSurvey() {
    container.innerHTML = "";
    
    // Détection titre long pour SurveyJS
    const surveyTitle = data.definition?.title || "";
    if (surveyTitle.length > 50) {
      container.classList.add("long-title-survey");
    } else {
      container.classList.remove("long-title-survey");
    }

    const survey = new Model(data.definition);
    survey.locale = "fr";
    survey.showCompletedPage = false; // Important: we handle it ourselves

    if (data.branding) {
      if (data.branding.logoUrl) {
        (survey as any).logo = data.branding.logoUrl;
        (survey as any).logoPosition = "right";
        (survey as any).logoWidth = 400;
        (survey as any).logoHeight = 150;
      }
      survey.applyTheme({
        cssVariables: {
          "--sjs-primary-color": data.branding.primaryColor || "#f2513c",
          "--sjs-primary-backcolor": data.branding.primaryColor || "#f2513c",
          "--sjs-secondary-backcolor": data.branding.secondaryColor || "#a0d348",
          "--sjs-special-color": data.branding.accentColor || "#2098ae",
          "--sjs-general-backcolor": "#ffffff",
          "--sjs-font-family": data.branding.fontFamily || "var(--font-family)",
        }
      });
    }

    Object.entries(prefillData).forEach(([key, value]) => {
      survey.setVariable(key, value);
    });

    if (data.labels) {
      if (data.labels.completeText) survey.completeText = data.labels.completeText;
    }

    if (data.customJs) {
      try {
        const f = new Function("survey", data.customJs);
        f(survey);
      } catch (err) {
        console.error("Error executing custom JS:", err);
      }
    }

    survey.onComplete.add(async (sender) => {
      const payload = { ...sender.data };
      if (token) {
        payload.__token = token;
      }

      const submitPromise = fetch(`${apiUrl}/projects/${projectId}/surveys/${surveyId}/submit`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      showGenericCompletionPage();

      await submitPromise;
    });

    renderSurvey(survey, container);
  }

  if (data.welcomePage && data.welcomePage.title) {
    const wp = data.welcomePage;
    const isLongTitle = wp.title && wp.title.length > 50;
    const titleClass = isLongTitle ? "long-title" : "";
    const branding = data.branding || {};
    container.innerHTML = `
      <div id="landingPage">
        <div class="page-header">
          <h1 class="${titleClass}">${wp.title}</h1>
          ${branding.logoUrl ? `<img src="${branding.logoUrl}" alt="Logo" />` : ""}
        </div>
        <div class="welcome-text">${wp.welcomeText}</div>
        ${
          wp.expandableTitle && wp.isExpandable !== false
            ? `
          <div class="expand-section">
            <div class="expand-trigger" id="expandTrigger">${wp.expandableTitle}</div>
            <div class="expand-content" id="expandContent">${wp.expandableContent}</div>
          </div>
        `
            : ""
        }
        <div class="actions">
          <button id="startBtn">Commencer le sondage</button>
          ${
            wp.moreInfoUrl
              ? `<a href="${wp.moreInfoUrl}" class="more-info" target="_blank">${wp.moreInfoLabel || "Pour en savoir plus"}</a>`
              : ""
          }
        </div>
      </div>
    `;

    document.getElementById("expandTrigger")?.addEventListener("click", (e) => {
      const trigger = e.currentTarget as HTMLElement;
      const content = document.getElementById("expandContent");
      trigger.classList.toggle("open");
      content?.classList.toggle("open");
    });

    document.getElementById("startBtn")?.addEventListener("click", () => {
      startSurvey();
    });
  } else {
    startSurvey();
  }

  document.head.appendChild(style);
}

init();
